import { firestore } from '../src/firebase-config';
import { id_firebase } from "./content-site";

export default function XML() {
    firestore.collection("revenda").doc(id_firebase).collection("veiculos")
        .where("veremovido", "==", 0).where("vevendido", "==", 0).orderBy("updated_at", "desc")
        .get()
        .then(querySnapshot => {
            var items = [];
            querySnapshot.forEach(doc => {
                var document = doc.data();
                document.id = doc.id;
                if (document["veexibir_site"] !== false) {
                    items.push(document);
                }
            });

            function escapeXml(unsafe) {
                return unsafe.replace(/[<>&'"]/g, function (c) {
                    switch (c) {
                        case '<': return '&lt;';
                        case '>': return '&gt;';
                        case '&': return '&amp;';
                        case '\'': return '&apos;';
                        case '"': return '&quot;';
                    }
                });
            }

            function listaXML(items) {
                let xmlDoc = document.implementation.createDocument("", "", null);
                let rss = xmlDoc.createElement("rss");
                rss.setAttribute("version", "2.0");
                rss.setAttribute("xmlns:g", "http://base.google.com/ns/1.0");

                let channel = xmlDoc.createElement("channel");

                let title = xmlDoc.createElement("title");
                title.textContent = "Catálogo de Veículos";
                channel.appendChild(title);

                let link = xmlDoc.createElement("link");
                link.textContent = "https://veiculospremiumuberlandia.com.br";
                channel.appendChild(link);

                let description = xmlDoc.createElement("description");
                description.textContent = "Catálogo de veículos para venda";
                channel.appendChild(description);

                items.forEach(item => {
                    let itemElement = xmlDoc.createElement("item");

                    let id = xmlDoc.createElement("g:id");
                    id.textContent = escapeXml(item.id);
                    itemElement.appendChild(id);

                    let title = xmlDoc.createElement("g:title");
                    title.textContent = escapeXml(item.vefipe_name || "Sem título");
                    itemElement.appendChild(title);

                    let description = xmlDoc.createElement("g:description");
                    description.textContent = escapeXml(`
                        Marca: ${item.vefipe_marca || "N/A"},
                        Modelo: ${item.vefipe_name || "N/A"},
                        Quilometragem: ${item.vequilometragem || "0"} km,
                        Ano: ${item.veano_fabricacao || "N/A"},
                        Ano do Modelo: ${item.vefipe_ano_modelo || "N/A"},
                        Combustível: ${item.vefipe_combustivel || "N/A"},
                        Câmbio: ${item.vecambio || "N/A"},
                        Cor: ${item.vecor || "N/A"},
                        Portas: ${item.veportas || "N/A"}
                    `);
                    itemElement.appendChild(description);

                    let link = xmlDoc.createElement("g:link");
                    link.textContent = escapeXml(`https://veiculospremiumuberlandia.com.br/#/veiculo/${item.id}`);
                    itemElement.appendChild(link);

                    let image_link = xmlDoc.createElement("g:image_link");
                    image_link.textContent = escapeXml(
                        item.imagens && item.imagens[0]?.fileUrl 
                            ? item.imagens[0].fileUrl 
                            : "https://sualoja.com/imagem-padrao.jpg"
                    );
                    itemElement.appendChild(image_link);

                    let condition = xmlDoc.createElement("g:condition");
                    condition.textContent = item.veveiculonovo === 1 ? 'new' : 'used';
                    itemElement.appendChild(condition);

                    let availability = xmlDoc.createElement("g:availability");
                    availability.textContent = item.vevendido === 0 ? 'in stock' : 'out of stock';
                    itemElement.appendChild(availability);

                    let price = xmlDoc.createElement("g:price");
                    price.textContent = `${item.vevalor || "0.00"} BRL`;
                    itemElement.appendChild(price);

                    let brand = xmlDoc.createElement("g:brand");
                    brand.textContent = escapeXml(item.vefipe_marca || "Desconhecida");
                    itemElement.appendChild(brand);

                    let model = xmlDoc.createElement("g:model");
                    model.textContent = escapeXml(item.vefipe_name || "Desconhecido");
                    itemElement.appendChild(model);

                    let color = xmlDoc.createElement("g:color");
                    color.textContent = escapeXml(item.vecor || "N/A");
                    itemElement.appendChild(color);

                    let doors = xmlDoc.createElement("g:doors");
                    doors.textContent = item.veportas || "0";
                    itemElement.appendChild(doors);

                    let fuel = xmlDoc.createElement("g:fuel");
                    fuel.textContent = escapeXml(item.vefipe_combustivel || "N/A");
                    itemElement.appendChild(fuel);

                    let km = xmlDoc.createElement("g:km");
                    km.textContent = item.vequilometragem || "0";
                    itemElement.appendChild(km);

                    channel.appendChild(itemElement);
                });

                rss.appendChild(channel);
                xmlDoc.appendChild(rss);

                let serializer = new XMLSerializer();
                let xmlString = `<?xml version="1.0" encoding="UTF-8"?>\n` + serializer.serializeToString(xmlDoc);
                return xmlString;
            }

            function saveFile(nomeArquivo, conteudo) {
                const blob = new Blob([conteudo], { type: "application/xml" });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = nomeArquivo;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            const xmlString = listaXML(items);
            saveFile("estoque.xml", xmlString);

            localStorage.setItem('xmlDownloaded', true);
        });
}
